module.exports = __webpack_public_path__ + "static/media/instagram.d90f0c9d.svg";